export default __webpack_public_path__ + "static/media/prestation transport.829d9df3.png";